import { enforce, test } from "vest";
import { trans } from "@/service/i18n/i18n";
import { accessFormFieldValue, createFieldName } from "@/forms/form-field";

export function createCheckboxFieldValidationSuite(
  definition: CheckboxField,
  formValue: any,
): void {
  const value = accessFormFieldValue(definition, formValue);

  test(
    createFieldName(definition),
    trans("form_validation.checkbox.required"),
    () => {
      if (definition.required) {
        enforce(value).isTruthy();
      }
    },
  );
}
